import { DataStartedAt, dataStartedAt } from '@edgvr-front/data/domain';
import { workshopName, WorkshopName } from '@edgvr-front/workshops/domain';
import { Validate } from '@edgvr-front/util/validate';

export class DataWorkshopsListRequestDTO {
  private static validation = Validate.compile(
    DataWorkshopsListRequestDTO.validationSchema()
  );

  constructor(readonly data: DataWorkshopsListRequestDTORaw) {
    Validate.assert(DataWorkshopsListRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['page'],
      properties: {
        workshopName,
        page: {
          type: 'number',
          minimum: 1,
        },
        from: dataStartedAt,
        to: dataStartedAt,
      },
    };
  }
}

interface DataWorkshopsListRequestDTORaw {
  workshopName?: WorkshopName;
  page: number;
  from?: DataStartedAt;
  to?: DataStartedAt;
}
